'use client'

import { useState } from 'react'

export interface CategoryData {
  uid: string
  name: string
  tags?: (number | string)[]
}

export interface ArticleCategoriesClientProps {
  categories: CategoryData[]
  editableProps?: Record<string, unknown>
}

export const ArticleCategoriesClient = ({ categories, editableProps }: ArticleCategoriesClientProps) => {
  const [_activeCategory, setActiveCategory] = useState<string | null>(null)

  // TODO: Implement category filtering and article loading

  return (
    <section {...editableProps}>
      {/* Category tabs */}
      <nav>
        {categories.map((category) => (
          <button
            key={category.uid}
            type="button"
            data-tracking="ignore"
            onClick={() => setActiveCategory(category.uid)}
          >
            {category.name}
          </button>
        ))}
      </nav>

      {/* Article grid - to be populated */}
      <div>{/* TODO: Load and display articles by category */}</div>
    </section>
  )
}
